import React, { useContext, useRef } from 'react';
import { MainContext } from '../context/main.context';
import ManualController from './ManualController';
import { getUserPaymentData } from '../stores/payment.store';
import {
    PAYMENT_EXIT,
    PAYMENTS_GET_USER_PAYMENT_DATA_ERROR,
    PAYMENTS_STATE_REVOCABLE_ERROR,
} from '../common/errorCodes';
import { useTranslation } from 'react-i18next';
import Modal from '../components/modal/Modal';
import { IsOkSvg, PaymentStateErrorSvg } from '../icons';


export default function PaymentState() {
    const { setPaymentPopupData } = useContext(MainContext);
    const { manualRedirect } = ManualController();
    const checkPaymentIntervalRef = useRef<any>(null);
    const popupRef = useRef<any>(null);

    const startCheckUserPaymentState = (url: string, paymentId: string) => {
        popupRef.current = window.open(url, '_blank');

        setPaymentPopupData({ status: 'pending' });

        checkPaymentIntervalRef.current = setInterval(() => {
            _checkUserPaymentState(paymentId);
        }, 2000);
    }

    const _checkUserPaymentState = (paymentId: string) => {
        getUserPaymentData(paymentId).then(res => {
            const status: any = res?.data?.status;
            const payload: any = res?.data?.payload || {};

            if ([ 'none', 'fail' ].includes(status)) {
                setPaymentPopupData({ status });
                _cancel();
                return;
            }

            if (status === 'paid') {
                const token = res?.data?.token;

                setPaymentPopupData({ status: 'paid', data: { payload, token } });
                _cancel();
                return;
            }

            if (popupRef?.current?.closed) {
                setPaymentPopupData({ status: 'none' });
                _cancel();
            }
        }, err => {
            const errData = err?.response?.data || err;
            manualRedirect(errData, 'auth', true, PAYMENTS_GET_USER_PAYMENT_DATA_ERROR);
        });
    }

    const _cancel = () => {
        clearInterval(checkPaymentIntervalRef.current);
    }

    return {
        startCheckUserPaymentState,
    }
}

export function PaymentStatePending() {
    const { t } = useTranslation();
    const { paymentPopupData } = useContext(MainContext);

    return (
        <>
            {
                paymentPopupData?.status === 'pending' && (
                    <Modal hideCloseButton open>
                        <div className="payment-state-modal">
                            <div className="payment-state-modal-title" style={{ alignItems: 'center' }}>
                                {t('payment.state.progress')}
                            </div>
                            <div className="payment-state-modal-throbber-box">
                                <div className="payment-state-modal-throbber"/>
                            </div>
                            <div className="payment-state-modal-description text-overflow">
                                {t('payment.state.wait')}...
                            </div>
                        </div>
                    </Modal>
                )
            }
        </>
    );
}

export function PaymentStatePaid() {
    const { paymentPopupData, setPaymentPopupData } = useContext(MainContext);
    const { manualRedirect } = ManualController();
    const { t } = useTranslation();

    const _cancel = () => {
        setPaymentPopupData(null);
        manualRedirect(paymentPopupData?.data, 'payment');
    }

    return (
        <>
            {
                paymentPopupData?.status === 'paid' && (
                    <Modal hideCloseButton open>
                        <div className="payment-state-modal">
                            <div className="payment-state-paid-modal-title">
                                <div className="payment-state-modal-title-img">
                                    <IsOkSvg/>
                                </div>
                                <div>
                                    {t('payment.state.paid')}
                                </div>
                            </div>
                            <div className="payment-state-paid-modal-description text-overflow">
                                {t('payment.state.successful')}.
                            </div>
                            <button className="payment-state-modal-button" onClick={_cancel}>
                                Ok
                            </button>
                        </div>
                    </Modal>
                )
            }
        </>
    );
}

export function PaymentStateRevocable() {
    const { paymentPopupData, setPaymentPopupData } = useContext(MainContext);
    const { manualRedirect } = ManualController();
    const { t } = useTranslation();

    const _cancel = () => {
        setPaymentPopupData(null);

        if (paymentPopupData?.status === 'none') {
            manualRedirect({}, 'payment', true, PAYMENT_EXIT);
        } else if (paymentPopupData?.status === 'fail') {
            manualRedirect({}, 'payment', true, PAYMENTS_STATE_REVOCABLE_ERROR);
        }
    }

    return (
        <>
            {
                paymentPopupData?.status && [ 'none', 'fail' ].includes(paymentPopupData.status) && (
                    <Modal hideCloseButton open>
                        <div className="payment-state-modal">
                            <div className="payment-state-revocable-modal-title">
                                <div className="payment-state-modal-title-img">
                                    <PaymentStateErrorSvg/>
                                </div>
                                <div>
                                    {t('payment.state.notPaid')}
                                </div>
                            </div>
                            <div className="payment-state-revocable-modal-description text-overflow">
                                {
                                    paymentPopupData.status === 'fail' ?
                                        t('payment.state.error')
                                    :
                                        t('payment.state.cancelled')
                                }
                            </div>
                            <button className="payment-state-modal-button" onClick={_cancel}>
                                {t('payment.state.cancel')}
                            </button>
                        </div>
                    </Modal>
                )
            }
        </>
    );
}